import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import questionReducer from './slices/QuestionSlice'
export const store = configureStore({
  reducer: {
    user: userReducer,
    question:questionReducer
  },
});